export default __webpack_public_path__ + "static/media/SanathanTextile_Dec21'3476.e93d7fa9.jpg";